import styled from 'styled-components';
import { colors } from '../colors';

interface sidebarProps {
	sidebarHide?: boolean;
	sidebarHideBidPackage?: boolean;
}
const Sidebar = styled.div<sidebarProps>`
	display: inline-block;
	background: ${colors.White};
	box-shadow: 0px -1px 31px rgba(0, 0, 0, 0.06);
	width: 250px;
	min-height: calc(100vh - 75px);
	height: auto;
	float: left;
	transition: margin 0.4s ease 0s;
	${({ sidebarHide }) =>
		sidebarHide &&
		`margin-left:-250px;
    `};
	${({ sidebarHideBidPackage }) =>
		sidebarHideBidPackage &&
		`margin-left:-30px;
		 margin-top: -30px;
		 
    `}
`;

export default Sidebar;
